import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, TrendingUp, Gift } from 'lucide-react';
import ArbitrageExample from './ArbitrageExample';
import OpportunityChart from './OpportunityChart';
import './Home.css';

function Home() {
  return (
    <div style={{ backgroundColor: '#0a0e1a' }}>
      {/* Hero Section */}
      <section className="home-hero" style={{
        background: 'linear-gradient(180deg, #0a0e1a 0%, #1a1f2e 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background grid effect - describe: Subtle grid pattern or data visualization in background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'linear-gradient(#2d3748 1px, transparent 1px), linear-gradient(90deg, #2d3748 1px, transparent 1px)',
          backgroundSize: '50px 50px',
          opacity: 0.1
        }}></div>

        <div style={{ 
          maxWidth: '1400px', 
          margin: '0 auto',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{ 
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <div style={{
              display: 'inline-block',
              padding: '8px 20px',
              backgroundColor: 'rgba(0, 217, 255, 0.1)',
              border: '1px solid rgba(0, 217, 255, 0.3)',
              borderRadius: '20px',
              marginBottom: '30px'
            }}>
              <span style={{ 
                fontSize: '13px',
                color: '#00d9ff',
                fontWeight: '600',
                letterSpacing: '0.5px',
                textTransform: 'uppercase'
              }}>
                Professional Advantage Betting Platform
              </span>
            </div>

            <h1 className="home-hero-title" style={{
              fontWeight: '800',
              lineHeight: '1.2',
              margin: '0 0 30px 0',
              background: 'linear-gradient(135deg, #ffffff 0%, #a0aec0 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-1px'
            }}>
              Bet Like a{' '}
              <span style={{
                background: 'linear-gradient(135deg, #00d9ff 0%, #10b981 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Pro
              </span>
            </h1>

            <p className="home-hero-subtitle" style={{
              lineHeight: '1.6',
              color: '#64748b',
              maxWidth: '600px',
              margin: '0 auto 50px'
            }}>
              Real-time arbitrage opportunities, positive EV detection, and bonus bet optimization. 
              Professional tools for smart bettors.
            </p>

            <div className="home-cta-buttons">
              <Link to="/signup">
                <button className="home-cta-btn-primary" style={{
                  background: 'linear-gradient(135deg, #00d9ff 0%, #10b981 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  color: '#0a0e1a',
                  fontWeight: '700',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 8px 24px rgba(0, 217, 255, 0.4)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 12px 32px rgba(0, 217, 255, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 24px rgba(0, 217, 255, 0.4)';
                }}
                >
                  Try Free for 7 Days
                </button>
              </Link>
              <Link to="/how-it-works">
                <button className="home-cta-btn-secondary" style={{
                  backgroundColor: 'transparent',
                  border: '2px solid #2d3748',
                  borderRadius: '10px',
                  color: '#ffffff',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.target.style.borderColor = '#00d9ff';
                  e.target.style.backgroundColor = 'rgba(0, 217, 255, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.target.style.borderColor = '#2d3748';
                  e.target.style.backgroundColor = 'transparent';
                }}
                >
                  Learn More
                </button>
              </Link>
            </div>

            {/* Stats bar */}
            <div className="home-stats-bar" style={{
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '15px'
            }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{ 
                fontSize: '36px', 
                fontWeight: '800',
                color: '#00d9ff',
                fontFamily: 'monospace'
                }}>
                18+
                </div>
                <div style={{ fontSize: '14px', color: '#64748b', marginTop: '8px' }}>
                Sportsbooks Tracked
                </div>
            </div>
            <div style={{ textAlign: 'center' }}>
                <div style={{ 
                fontSize: '36px', 
                fontWeight: '800',
                color: '#10b981',
                fontFamily: 'monospace'
                }}>
                24/7
                </div>
                <div style={{ fontSize: '14px', color: '#64748b', marginTop: '8px' }}>
                Real-Time Updates
                </div>
            </div>
            </div>
          </div>
        </div>
      </section>

      {/* Live Example Section */}
      <section style={{ padding: '80px 60px', backgroundColor: '#0a0e1a' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '36px' }}>
            <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#ffffff', margin: '0 0 12px 0' }}>
              See It In Action
            </h2>
            <p style={{ fontSize: '16px', color: '#64748b', margin: 0 }}>
              Two sportsbooks, two bets, profit either way.
            </p>
            <p style={{ fontSize: '12px', color: '#475569', marginTop: '8px' }}>
              Illustrative example only, not a real bet or current odds.
            </p>
          </div>
          <ArbitrageExample />
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link to="/how-it-works" style={{ color: '#00d9ff', fontSize: '14px', fontWeight: '600', textDecoration: 'none' }}>
              See more examples →
            </Link>
          </div>
        </div>
      </section>

        <OpportunityChart />

        {/* Features Section */}
        <section className="home-features-section" style={{ backgroundColor: '#0a0e1a' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{ 
                fontSize: '42px',
                fontWeight: '800',
                margin: '0 0 20px 0',
                color: '#ffffff'
            }}>
                Professional Tools for Every Strategy
            </h2>
            <p style={{ fontSize: '18px', color: '#64748b', maxWidth: '600px', margin: '0 auto' }}>
                Advanced analytics that give you an advantage in the sports betting market
            </p>
            </div>

            <div className="home-features-grid">
            {/* Arbitrage Tool */}
            <Link to="/arbitrage" style={{ textDecoration: 'none' }}>
                <div style={{
                padding: '40px',
                backgroundColor: '#1a1f2e',
                border: '1px solid #2d3748',
                borderRadius: '15px',
                transition: 'all 0.3s',
                cursor: 'pointer',
                height: '65%'
                }}
                onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#00d9ff';
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 217, 255, 0.2)';
                }}
                onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#2d3748';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                }}
                >
                <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, rgba(0, 217, 255, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%)',
                    border: '1px solid rgba(0, 217, 255, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px',
                    fontSize: '28px'
                }}>
                    <Zap size={28} color="#00d9ff" />
                </div>
                <h3 style={{ 
                    fontSize: '24px',
                    fontWeight: '700',
                    margin: '0 0 15px 0',
                    color: '#ffffff'
                }}>
                    Arbitrage Detection
                </h3>
                <p style={{ 
                    fontSize: '15px',
                    lineHeight: '1.7',
                    color: '#64748b',
                    marginBottom: '25px'
                }}>
                    Lock in profit by betting across multiple sportsbooks. Real-time updates 
                    ensure you never miss an advantage bet.
                </p>
                <div style={{
                    color: '#00d9ff',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                </div>
                </div>
            </Link>

            {/* Positive EV Tool */}
            <Link to="/positive-ev" style={{ textDecoration: 'none' }}>
                <div style={{
                padding: '40px',
                backgroundColor: '#1a1f2e',
                border: '1px solid #2d3748',
                borderRadius: '15px',
                transition: 'all 0.3s',
                cursor: 'pointer',
                height: '65%'
                }}
                onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#10b981';
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(16, 185, 129, 0.2)';
                }}
                onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#2d3748';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                }}
                >
                <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(0, 217, 255, 0.2) 100%)',
                    border: '1px solid rgba(16, 185, 129, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px',
                    fontSize: '28px'
                }}>
                    <TrendingUp size={28} color="#10b981" />
                </div>
                <h3 style={{ 
                    fontSize: '24px',
                    fontWeight: '700',
                    margin: '0 0 15px 0',
                    color: '#ffffff'
                }}>
                    Positive EV Finder
                </h3>
                <p style={{ 
                    fontSize: '15px',
                    lineHeight: '1.7',
                    color: '#64748b',
                    marginBottom: '25px'
                }}>
                    Identify bets with long-term positive expected value. Built-in Kelly Criterion 
                    calculator for optimal bankroll management.
                </p>
                <div style={{
                    color: '#10b981',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                </div>
                </div>
            </Link>

            {/* Bonus Conversion */}
            <Link to="/promo-conversion" style={{ textDecoration: 'none' }}>
                <div style={{
                padding: '40px',
                backgroundColor: '#1a1f2e',
                border: '1px solid #2d3748',
                borderRadius: '15px',
                transition: 'all 0.3s',
                cursor: 'pointer',
                height: '65%'
                }}
                onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#f59e0b';
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(245, 158, 11, 0.2)';
                }}
                onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#2d3748';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                }}
                >
                <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%)',
                    border: '1px solid rgba(245, 158, 11, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '25px',
                    fontSize: '28px'
                }}>
                    <Gift size={28} color="#f59e0b" />
                </div>
                <h3 style={{ 
                    fontSize: '24px',
                    fontWeight: '700',
                    margin: '0 0 15px 0',
                    color: '#ffffff'
                }}>
                    Bonus Optimization
                </h3>
                <p style={{ 
                    fontSize: '15px',
                    lineHeight: '1.7',
                    color: '#64748b',
                    marginBottom: '25px'
                }}>
                    Maximize the value of promotional offers like bonus bets. Convert free bets 
                    into real cash with optimal hedging strategies.
                </p>
                <div style={{
                    color: '#f59e0b',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                </div>
                </div>
            </Link>
            </div>
        </div>
        </section>

      {/* Testimonials Section — hidden until real reviews collected
      <section style={{
        padding: '100px 60px',
        backgroundColor: '#0a0e1a'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '42px',
              fontWeight: '800',
              margin: '0 0 20px 0',
              color: '#ffffff'
            }}>
              Trusted by Professional Bettors
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '30px'
          }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                padding: '30px',
                backgroundColor: '#1a1f2e',
                border: '1px solid #2d3748',
                borderRadius: '12px'
              }}>
                <div style={{
                  height: '200px',
                  backgroundColor: '#0f1419',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#64748b',
                  fontSize: '14px'
                }}>
                  [User Testimonial Screenshot {i}]
                </div>
                <p style={{
                  fontSize: '14px',
                  color: '#64748b',
                  fontStyle: 'italic'
                }}>
                  Placeholder for positive user feedback and recommendation
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}
    </div>
  );
}

export default Home;